import { Navigate, useLocation } from "react-router";
import { useAuthV2 } from "@cliently/auth-client";
import { useAuthSyncV2 } from "./use-auth-sync-v2";
import { useAuthStore } from "../stores/auth.store";

interface Props {
  children: React.ReactNode;
}

/**
 * Équivalent auth-v2 de `ProtectedRoute` (App.tsx). Même comportement :
 *  - Splash tant que l'auth n'est pas chargée.
 *  - Redirection /sign-in si non connecté.
 *  - Redirection /onboarding si org non onboardée.
 *  - Redirection /forbidden si l'utilisateur appartient à l'app client.
 */
export const ProtectedRouteV2 = ({ children }: Props) => {
  const { isSignedIn, isLoaded } = useAuthV2();
  const authReady = useAuthSyncV2();
  const org = useAuthStore((s) => s.org);
  const location = useLocation();

  if (authReady === "client_blocked") {
    return <Navigate to="/forbidden" replace />;
  }

  if (!isLoaded || (isSignedIn && !authReady)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="border-primary h-8 w-8 animate-spin rounded-full border-4 border-t-transparent" />
      </div>
    );
  }
  if (!isSignedIn) {
    const redirect = encodeURIComponent(
      location.pathname + location.search,
    );
    return <Navigate to={`/sign-in?redirect=${redirect}`} replace />;
  }

  if (
    org &&
    !org.onboardingCompleted &&
    !location.pathname.startsWith("/onboarding")
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};
